module.exports = __webpack_public_path__ + "static/assets/53fd61dc1dfee931378e14e177aa67b3.svg";